const eventTag = {
  event: '',
  env_type: 'alelo:b2b',
  app_name: 'credenciamento-web',
  section_app: 'credenciamento',
  screen_name: '',
  element_type: '',
  element_content: '',
  screen_type: 'pagina',
  hash_cpf: '',
  hash_cnpj: '',
  num_ec: ''
};

export const pushInteractionTagManager = ({
  screenName,
  elementType,
  elementContent
}) => {
  const event = {
    event: 'interaction',
    screen_name: screenName,
    element_type: elementType,
    element_content: elementContent
  };
  global.dataLayer.push({...eventTag, ...event});
};

export const pushInteractionTagManagerChatbot = ({
  screenName,
  elementType,
  elementContent
}) => {
  const event = {
    event: 'interaction',
    app_name: 'credenciamento-web-chatbot',
    section_app: 'credenciamento-chatbot',
    screen_name: screenName,
    element_type: elementType,
    element_content: elementContent
  };
  global.dataLayer.push({...eventTag, ...event});
};

export const pushNoInteractionTagManagerChatbot = ({elementContent}) => {
  const event = {
    event: 'nointeraction',
    app_name: 'credenciamento-web-chatbot',
    section_app: 'credenciamento-chatbot',
    screen_name: 'credenciamento:chatbot',
    element_type: 'chat:screen:view',
    element_content: elementContent
  };
  global.dataLayer.push({...eventTag, ...event});
};

export const pushViewTagManager = ({
  screenName,
  appName,
  sectionApp,
  eventName
}) => {
  let event = {
    event_name: eventName || 'screen_view',
    screen_name: screenName,
    app_name: appName,
    section_app: sectionApp
  };
  global.dataLayer.push({...eventTag, ...event});
};
